self.onmessage = function handleMessageFromMain(msg) {
  
    var qty = 0;
    Object.values(msg.data.gorders).forEach((order,k) => {
          try { 
      if (order.purchaseorder_id == msg.data.purchaseorderid) {
        if (order.products) {
            var op = JSON.parse(order.products);
            op.forEach((opr,productkey) => { 
              if (opr.qty_ordered && opr.projected_delivery) {
                //var projectedtest = moment(opr.projected_delivery, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
                  if (msg.data.productrow == productkey+1) {
                    qty -= opr.qty_ordered;
                  }
                } else { }
            })
        }
      }
          } catch(e) { console.warn(e); }
    });
    var acommand = "document.querySelector('#inv-current-" + msg.data.purchaseorderid + '-' + msg.data.productrow + "').innerHTML = " + qty;
    self.postMessage(acommand);
  
  };
